export default __webpack_public_path__ + "static/service_industrial@2x-6d940c1207e387a3838bbf438cf3b1e3.jpg";